import { render, staticRenderFns } from "./message-tip.vue?vue&type=template&id=7051873f&scoped=true"
import script from "./message-tip.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-tip.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-tip.vue?vue&type=style&index=0&id=7051873f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7051873f",
  null
  
)

export default component.exports